module.exports = __webpack_public_path__ + "img/ic_24_facebook.f6ce332c.svg";